<template>
  <div
    class="custom-hiprint"
    v-loading="resolvedConfig.businessFields.isLoading"
    :element-loading-text="resolvedConfig.businessFields.loadingText"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.9)"
  >
    <!-- 主要内容 -->
    <div class="custom-hiprint-header">
      <el-dropdown @command="handleLanguageChange">
        <el-button class="operate-icon-btn" link>
          <i class="erp-print-iconfont erp-print-icon-duoyuyan1"></i>
          <span style="margin-left: 4px">{{ currentLanguageLabel }}</span>
        </el-button>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item v-for="item in languages" :key="item.value" :command="item.value">
              {{ item.label }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <div class="vertical-line"></div>
      <el-tooltip
        class="box-item"
        effect="dark"
        :content="t('designer.zoom.zoomOut')"
        placement="top"
      >
        <el-button
          class="operate-icon-btn"
          link
          @click="changeScaleHandler((scaleValue - 10) / 100, printInstance)"
          :disabled="scaleValue <= scaleMin"
        >
          <i class="erp-print-iconfont erp-print-icon-suoxiao1"></i>
        </el-button>
      </el-tooltip>
      <span class="scale-value">{{ scaleValue }}%</span>
      <el-tooltip
        class="box-item"
        effect="dark"
        :content="t('designer.zoom.zoomIn')"
        placement="top"
      >
        <el-button
          class="operate-icon-btn"
          link
          @click="changeScaleHandler((scaleValue + 10) / 100, printInstance)"
          :disabled="scaleValue >= scaleMax"
        >
          <i class="erp-print-iconfont erp-print-icon-fangda1"></i>
        </el-button>
      </el-tooltip>
      <div class="vertical-line"></div>
      <el-tooltip
        class="box-item"
        effect="dark"
        :content="t('designer.actions.undo')"
        placement="top"
      >
        <el-button class="operate-icon-btn" link @click="undoHandler">
          <i class="erp-print-iconfont erp-print-icon-chexiao"></i>
        </el-button>
      </el-tooltip>
      <el-tooltip
        class="box-item"
        effect="dark"
        :content="t('designer.actions.redo')"
        placement="top"
      >
        <el-button class="operate-icon-btn" link @click="redoHandler">
          <i class="erp-print-iconfont erp-print-icon-fanchexiao"></i>
        </el-button>
      </el-tooltip>
      <div class="vertical-line"></div>
      <el-tooltip
        class="box-item"
        effect="dark"
        :content="t('designer.actions.rotate')"
        placement="top"
      >
        <el-button class="operate-icon-btn" link @click="rotatePaperWrapper">
          <i class="erp-print-iconfont erp-print-icon-xuanzhuan1"></i>
        </el-button>
      </el-tooltip>
      <el-popconfirm
        :title="t('designer.actions.confirmClear')"
        confirm-button-type="danger"
        :confirm-button-text="t('designer.actions.confirm')"
        @confirm="clearPaper"
      >
        <template #reference>
          <el-button class="operate-icon-btn" link
            ><i class="erp-print-iconfont erp-print-icon-qingchubiaoshi"></i
          ></el-button>
        </template>
      </el-popconfirm>
      <div class="vertical-line"></div>
      <el-button
        class="operate-icon-btn"
        :class="grid ? 'grid-on' : 'grid-off'"
        link
        @click="toggleGrid"
      >
        <i class="erp-print-iconfont erp-print-icon-24gl-grid"></i>
      </el-button>
      <el-tooltip
        class="box-item"
        effect="dark"
        :content="t('designer.actions.jsonPreview')"
        placement="top"
      >
        <el-button class="operate-icon-btn" link @click="showJsonView">
          <i class="erp-print-iconfont erp-print-icon-json"></i>
        </el-button>
      </el-tooltip>
      <el-tooltip
        class="box-item"
        effect="dark"
        :content="t('designer.actions.preview')"
        placement="top"
      >
        <el-button class="operate-icon-btn" link @click="preViewHandler">
          <i class="erp-print-iconfont erp-print-icon-yulan"></i>
        </el-button>
      </el-tooltip>
      <el-dropdown @command="exportHandler">
        <el-button class="operate-icon-btn" link>
          <i class="erp-print-iconfont erp-print-icon-daochu5"></i>
        </el-button>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="exportPdf">导出空模板</el-dropdown-item>
            <el-dropdown-item command="exportPdf:demo">导出模板（demo数据）</el-dropdown-item>
            <!-- <el-dropdown-item command="exportPdf:arraybuffer">{{
              t('designer.export.exportPdfArrayBuffer')
            }}</el-dropdown-item>
            <el-dropdown-item command="exportPdf:dataurl">{{
              t('designer.export.exportPdfDataUrl')
            }}</el-dropdown-item>
            <el-dropdown-item command="exportPdf:bloburl">{{
              t('designer.export.exportPdfBlobUrl')
            }}</el-dropdown-item>
            <el-dropdown-item command="exportPdf:dataurlstring">{{
              t('designer.export.exportPdfDataUrlString')
            }}</el-dropdown-item> -->
            <el-dropdown-item command="exportPdf:pdfobjectnewwindow">{{
              t('designer.export.exportPdfObjectNewWindow')
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <el-dropdown @command="handleMenuClick">
        <el-button class="operate-icon-btn" link>
          <i class="erp-print-iconfont erp-print-icon-dayin-dayinji"></i>
        </el-button>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="print:browser">{{
              t('designer.print.browser')
            }}</el-dropdown-item>
            <el-dropdown-item command="print:printer">{{
              t('designer.print.printer')
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>

      <!-- 操作按钮插槽 -->
      <div style="margin-left: auto">
        <slot name="custom-header-btn">
          <el-button @click="handleCancel()">{{ t('designer.cancel') }}</el-button>
          <el-button @click="handleSave(printInstance, props.modelValue)">{{
            t('designer.save')
          }}</el-button>
        </slot>
      </div>
    </div>

    <div class="custom-hiprint-content">
      <div class="custom-hiprint-menu">
        <el-scrollbar height="100%">
          <!-- 基本信息 -->
          <el-form class="base-info-form" :model="form" label-width="80px" label-position="top">
            <el-form-item :label="t('designer.templateName')">
              <el-input v-model="form.name" />
            </el-form-item>
            <el-form-item :label="t('designer.paperType')">
              <el-select
                v-model="form.paperType"
                @change="(value) => handlePaperTypeChange(value, printInstance)"
                :placeholder="t('designer.paperTypes.selectPaperType')"
              >
                <el-option
                  v-for="item in paperTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="t('designer.paperSettings')" v-if="form.paperType === 'custom'">
              <div class="paper-size-group">
                <el-input
                  v-model="form.customWidth"
                  class="size-input-first"
                  @change="otherPaperWrapper"
                />
                <el-input
                  v-model="form.customHeight"
                  class="size-input-last"
                  @change="otherPaperWrapper"
                >
                  <template #append>mm</template>
                </el-input>
              </div>
            </el-form-item>
          </el-form>
          <!-- 自定义插槽 -->
          <slot name="custom-form"></slot>
          <el-collapse ref="collapseRef" v-model="activeName" expand-icon-position="left">
            <!-- 基础控件 -->
            <el-collapse-item :title="t('designer.baseControls')" name="basecontrols">
              <div class="rect-printElement-types hiprintEpContainer base-controls">
                <div v-for="item in controlList" :key="item.type" class="drag_item_box">
                  <div class="ep-draggable-item" :tid="`defaultModule.${item.type}`">
                    <i
                      :class="`erp-print-iconfont erp-print-icon-${item.icon.replace('icon-', '')}`"
                    ></i>
                    <span class="control-item-name">{{ item.name }}</span>
                  </div>
                </div>
              </div>
            </el-collapse-item>
            <!-- 拖拽配置字段 -->
            <el-collapse-item
              v-for="group in businessFields.filter((e) => !e.tableExtensions)"
              :key="group.id"
              :title="group.name"
              :name="group.id"
            >
              <div class="business-fields">
                <div class="rect-printElement-types hiprintEpContainer business-fields-list">
                  <div v-for="item in group.variables" :key="item.id" class="drag_item_box">
                    <a
                      class="ep-draggable-item business-field-item"
                      :tid="`customModule.${item.field}.${item.fieldType}`"
                    >
                      {{ item.name }}
                    </a>
                  </div>
                </div>
              </div>
            </el-collapse-item>
            <!-- 表格拓展配置字段 -->
            <el-collapse-item
              v-for="group in businessFields.filter((e) => e.tableExtensions)"
              :key="group.id"
              :title="group.name"
              :name="group.id"
            >
              <div class="business-fields">
                <div class="business-fields-list">
                  <div
                    v-for="item in group.variables"
                    :key="item.id"
                    class="drag_item_box"
                    @click="handleTableColumnAdd(item)"
                  >
                    <span class="business-field-item">{{ item.name }}</span>
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-scrollbar>
      </div>
      <div class="custom-hiprint-content-body">
        <div id="hiprint-printTemplate" class="hiprint-printTemplate"></div>
        <div class="hiprint-printTemplate-setting">
          <div class="setting-title">{{ t('designer.propertyPanel') }}</div>
          <div id="PrintElementOptionSetting" class="params_setting_container">
            <div class="empty-setting">
              <el-icon><Pointer /></el-icon>
              {{ t('designer.selectElementToEdit') }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 预览 -->
    <template-preview ref="preView" />
    <!-- json预览 -->
    <json-view ref="jsonViewComponent" :template="printInstance" />

    <!-- 隐藏的文件上传组件 -->
    <el-upload
      ref="uploadRef"
      :show-file-list="false"
      :auto-upload="true"
      :action="uploadAction"
      :headers="uploadHeaders"
      :data="uploadData"
      :before-upload="beforeUpload"
      :on-success="onUploadSuccess"
      :on-error="onUploadError"
      accept="image/*"
      style="display: none"
    >
      <el-button ref="uploadTrigger" style="display: none">{{
        t('designer.upload.hiddenButton')
      }}</el-button>
    </el-upload>
  </div>
</template>

<script setup lang="ts">
// Props - 新的简化配置接口
interface PrintDesignerProps {
  /** 打印设计器配置对象 */
  config?: PrintDesignerConfig
  /** v-model绑定值，结构为 { baseForm: {}, templateJson: {} } */
  modelValue?: TemplateData
  /** 取消按钮事件 */
  cancelHandler?: () => void
  /** 保存按钮事件 */
  saveHandler?: (printInstance: any, modelValue: TemplateData) => void
}

const props = withDefaults(defineProps<PrintDesignerProps>(), {
  config: () => ({}),
  modelValue: () => ({ baseForm: {}, templateJson: {} }),
  cancelHandler: () => {},
  saveHandler: (printInstance: any, modelValue: TemplateData) => {
    console.log('saveHandler', printInstance, modelValue)
  },
})

import { ref, onMounted, watch, computed, nextTick } from 'vue'
import { ElMessage } from 'element-plus'
import { Pointer } from '@element-plus/icons-vue'
import * as vuePluginHiprint from './index'
import printData from './utils/print-data.js'
import TemplatePreview from './TemplatePreview.vue'
import jsonView from './JsonView.vue'
// import fontSize from './utils/font-size.js'
// import scale from './utils/scale.js'
// Composables
import { useScaleManagement } from './composables/useScaleManagement.js'
import { usePaperManagement } from './composables/usePaperManagement.js'
import { useElementOperations } from './composables/useElementOperations.js'
// 业务配置字段
import type { PrintDesignerConfig, TemplateData, BusinessField } from './types/PrintDesignerTypes'

// 配置解析 - 使用新的config配置，提供合理的默认值
const resolvedConfig = computed(() => {
  const config = props.config || {}

  return {
    upload: {
      action: config.upload?.action || '',
      allowedTypes: config.upload?.allowedTypes || [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/gif',
        'image/webp',
      ],
      maxSizeInMB: config.upload?.maxSizeInMB || 5,
      headers: config.upload?.headers || {},
      data: config.upload?.data || {},
    },
    businessFields: {
      fields: config.businessFields?.fields || [],
      async: config.businessFields?.async ?? false,
      isLoading: config.businessFields?.isLoading ?? false,
      loadingText: config.businessFields?.loadingText || '正在加载业务字段...',
    },
    // ui: {
    //   showGrid: config.ui?.showGrid ?? true,
    //   language: config.ui?.language || 'zh-CN',
    //   scale: {
    //     min: config.ui?.scale?.min || 10,
    //     max: config.ui?.scale?.max || 300,
    //     step: config.ui?.scale?.step || 10,
    //   },
    // },
    customControlList: config.customControlList || [],
  }
})

// 响应式业务字段数据处理
const businessFields = computed(() => {
  return resolvedConfig.value.businessFields.fields || []
})
// 监听业务字段变化，处理自动初始化
watch(
  () => resolvedConfig.value.businessFields.fields,
  (newFields, oldFields) => {
    if (resolvedConfig.value.businessFields.async) {
      // 异步模式：数据从空变为有数据时，自动初始化
      if ((!oldFields || oldFields.length === 0) && newFields && newFields.length > 0) {
        // 等待下一个tick确保DOM更新后再初始化
        nextTick(() => {
          const defaultExpandFields = newFields
            .filter((e: any) => e.defaultExpand)
            .map((e: any) => e.id)
          activeName.value = ['basecontrols'].concat(defaultExpandFields)
        })
      }
    }
  },
  { deep: true, immediate: true },
)

// 组件挂载时的初始化
onMounted(() => {
  // 其他初始化逻辑可以在这里添加
})

// 提供给外部调用的方法，用于手动刷新业务字段
const refreshBusinessFields = () => {
  if (resolvedConfig.value.businessFields.async) {
    // 触发父组件重新获取数据，父组件负责管理loading状态
    emit('business-fields-refresh')
  }
}

// 处理取消事件
const handleCancel = () => {
  emit('cancel')
  props.cancelHandler?.()
}

// 处理保存事件
const handleSave = (printInstance: any, modelValue: TemplateData) => {
  emit('save', printInstance, modelValue)
  props.saveHandler?.(printInstance, modelValue)
}

// 注意：defineExpose 在文件末尾统一处理

// 本地上传图片文件
import { useImageUpload } from './composables/useImageUpload.js'
// 表格交互
import { useTableInteraction } from './composables/useTableInteraction.js'
// 打印
import { usePrintAction } from './composables/usePrintAction.js'
// 基础控件
import { useControlList } from './composables/useControlList'
// 传递自定义列表
const { controlList } = useControlList(resolvedConfig.value.customControlList)

// 全局变量
declare const window: Window &
  typeof globalThis & {
    hiwebSocket: any
    $: any
  }

// 事件 - 新的标准化事件，带严格类型定义
const emit = defineEmits<{
  'template-init': [printInstance: any]
  'template-change': [data: TemplateData]
  'template-error': [error: any]
  'print-success': [result: { status: string; data: any }]
  'print-error': [error: { status: string; error: any }]
  'export-success': [result: { status: string; result: any }]
  'export-error': [error: { status: string; error: any }]
  'business-fields-refresh': []
  cancel: []
  save: [printInstance: any, data: TemplateData]
  'update:modelValue': [data: TemplateData]
}>()

let hiprint: any, defaultElementTypeProvider: any
const printInstance = ref<any>(null)

const activeName = ref<string[]>([])
const grid = ref(true)
// 组件实例
const preView = ref<any>(null)
const jsonViewComponent = ref<any>(null)
const collapseRef = ref<any>(null)

// 使用图片上传 hook - 使用解析后的配置
const {
  uploadRef,
  uploadAction,
  uploadHeaders,
  uploadData,
  beforeUpload,
  onUploadSuccess,
  onUploadError,
  handleImageChooseClick,
} = useImageUpload({
  // 使用解析后的配置项
  uploadAction: resolvedConfig.value.upload.action,
  allowedTypes: resolvedConfig.value.upload.allowedTypes,
  maxSizeInMB: resolvedConfig.value.upload.maxSizeInMB,
})
// 国际化语言切换 - 使用全局多语言系统
import { useErpI18n } from '@/composables/useErpI18n'
const {
  switchLanguage,
  supportedLanguages,
  currentLanguageName,
  currentLanguage,
  syncHiprintLanguage,
  t,
} = useErpI18n()

const currentLanguageLabel = computed(() => currentLanguageName.value)
const languages = computed(() =>
  supportedLanguages.value.map((lang) => ({
    label: lang.name,
    value: lang.code,
  })),
)

const handleLanguageChange = async (value: string) => {
  try {
    await switchLanguage(value as any)
    await init()
    // 切换语言后重新初始化，菜单不会刷新需手动点击重新生成属性面板，直接获取dom，手动触发一次点击事件
    const collapseDom = document.querySelector('.hiprint-printPanel')
    if (collapseDom) {
      ;(collapseDom as any).click()
    }
  } catch (error) {
    console.error('[Language Switch Debug] Language switch failed:', error)
  }
}
// 撤销 恢复
const undoHandler = () => {
  printInstance.value.undo()
}
const redoHandler = () => {
  printInstance.value.redo()
}

// 使用 composables
const { scaleValue, scaleMax, scaleMin, changeScaleHandler } = useScaleManagement()
const { form, paperTypes, handlePaperTypeChange, otherPaper, rotatePaper } = usePaperManagement()
const { getSelectTable, getAllTables } = useElementOperations()
// 使用表格交互方法
useTableInteraction()
// 添加业务字段到表格
const handleTableColumnAdd = (item: BusinessField) => {
  const tables = getSelectTable(printInstance.value)
  if (!tables.length) {
    ElMessage.warning(t('designer.messages.selectTableFirst'))
    return
  }
  const tableCoordinates: any = {}
  tables.forEach((e: any) => {
    const { qid, left, top, width, height } = e.options
    if (qid) {
      tableCoordinates[qid] = {
        left,
        top,
        width,
        height,
      }
    }
  })
  const json = JSON.parse(JSON.stringify(printInstance.value.getJson(), null, 2))
  const printElements = json.panels[0].printElements
  const tableElement = printElements.filter((e: any) => e.printElementType?.type === 'table')
  let newColumn = {
    width: 80,
    title: item.name,
    field: item.field,
    checked: true,
    columnId: item.field,
    isImage: item.isImage,
    fixed: false,
    rowspan: 1,
    colspan: 1,
  } as any

  if (item.isImage) {
    newColumn = {
      ...newColumn,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      renderFormatter: (value, row, colIndex, options, rowIndex) => {
        if (value) {
          const img = `<img style="margin: 4px auto;" width="80" height="80" src="${value}" alt="${value}" />`
          return img
        } else {
          return ''
        }
      },
    }
  }
  tableElement.forEach((e: any) => {
    const options = e.options
    if (tableCoordinates[options.qid]) {
      options.width += newColumn.width
      options.columns[0].push(newColumn)
      tableCoordinates[options.qid].width = options.width
    }
  })
  printInstance.value.update(json)
  const allTables = getAllTables(printInstance.value)
  const tableBK = allTables.filter((e: any) => tableCoordinates[e.options.qid])
  const tableBkID = tableBK.map((e: any) => e.id)
  const tableElements = document.querySelectorAll('.hiprint-printElement-table')
  tableElements.forEach((e: any) => {
    const tableID = e.getAttribute('tableID')
    if (tableBkID.includes(tableID)) {
      e.classList.add('table-active')
    }
  })
}
// 菜单事件

import { preparePrintEnvironment } from './utils/css-helper'

const { printAction, exportPDF } = usePrintAction()
const handleMenuClick = (command: string) => {
  const type = command.split(':')[1]
  if (type === 'browser') {
    printAction({
      printInstance: printInstance,
      printData: ref({}),
      waitShowPrinter: ref(false),
      callback: (status: string, error?: any) => {
        if (status === 'printSuccess') {
          ElMessage.success(t('designer.messages.printSuccess'))
          emit('print-success', { status, data: null })
        } else if (status === 'printError') {
          ElMessage.error(`${t('designer.messages.printFailed')}: ${error}`)
          emit('print-error', { status, error })
        }
      },
    })
  } else if (type === 'printer') {
    const printerList = printInstance.value.getPrinterList()
    console.log('打印机列表', printerList)

    // 在调用 print2 之前准备打印环境
    preparePrintEnvironment()

    printInstance.value.print2(printData, {
      printer: '',
      title: 'hiprint测试打印',
      duplexMode: 'simplex', // 单面打印
      styleHandler: () => {
        // 返回完整的打印样式，支持 npm 包发布
        // return getPrintStyles()
      },
      callback: () => {
        console.log('%c打印回调 >>>>>>>>>>>', 'color: green; font-size: 12px;')
      },
    })
  }
}

const exportHandler = (type: string) => {
  if (type === 'exportPdf') {
    exportPDF({
      printInstance: printInstance,
      printData: ref({}),
      download: true,
      type: 'blob',
      fileName: t('designer.export.defaultFileName'),
      callback: (status: string, res: any) => {
        console.log('res', res)
      },
    })
  } else if (type === 'exportPdf:demo') {
    exportPDF({
      printInstance: printInstance,
      printData: ref(printData),
      download: true,
      type: 'blob',
      fileName: t('designer.export.defaultFileName'),
      callback: (status: string, res: any) => {
        console.log('res', res)
      },
    })
  } else if (type === 'exportPdf:pdfobjectnewwindow') {
    exportPDF({
      printInstance: printInstance,
      printData: ref(printData),
      download: true,
      type: 'pdfobjectnewwindow',
      fileName: t('designer.export.defaultFileName'),
      callback: (status: string, res: any) => {
        console.log('res', res)
      },
    })
  }
}

const otherPaperWrapper = () => {
  otherPaper(printInstance.value)
}

const rotatePaperWrapper = () => {
  rotatePaper(printInstance.value)
}
// 清空纸张
const clearPaper = () => {
  try {
    printInstance.value.clear()
  } catch (error) {
    ElMessage.error(`${t('designer.messages.operationFailed')}: ${error}`)
  }
}

// 显示JSON预览
const showJsonView = () => {
  try {
    jsonViewComponent.value?.show()
  } catch (error) {
    ElMessage.error(`${t('designer.messages.operationFailed')}: ${error}`)
  }
}

// 预览
const preViewHandler = () => {
  // 测试, 点预览更新拖拽元素
  // hiprint.updateElementType('defaultModule.text', (type: any) => {
  //   type.title = t('designer.test.updatedElement')
  //   return type
  // })

  // 测试, 通过socket刷新打印机列表； 默认只有连接的时候才会获取到最新的打印机列表
  hiprint.refreshPrinterList((list: any) => {
    console.log('refreshPrinterList')
    console.log(list)
  })

  // 测试, 获取IP、IPV6、MAC地址、DNS
  hiprint.getAddress('ip', (data: any) => {
    console.log('ip')
    console.log(data)
  })
  hiprint.getAddress('ipv6', (data: any) => {
    console.log('ipv6')
    console.log(data)
  })
  hiprint.getAddress('mac', (data: any) => {
    console.log('mac')
    console.log(data)
  })
  hiprint.getAddress('dns', (data: any) => {
    console.log('dns')
    console.log(data)
  })
  hiprint.getAddress('all', (data: any) => {
    console.log('all')
    console.log(data)
  })
  hiprint.getAddress(
    'interface',
    (data: any) => {
      console.log('interface')
      console.log(data)
    },
    'IPv4',
    'eth1',
  )

  preView.value?.show(printInstance.value, printData, {
    templateName: 'xxx模板',
  })
}

// 监听baseform变化，同步到内部form
watch(
  () => props.modelValue?.baseForm,
  (newBaseform) => {
    if (newBaseform && Object.keys(newBaseform).length > 0) {
      // 同步baseform数据到内部form
      Object.assign(form, newBaseform)
    }
  },
  { deep: true, immediate: true },
)

// 监听form变化，emit到baseform
watch(
  () => form.name,
  (newName, oldName) => {
    if (newName !== oldName) {
      const currentFullJson = props.modelValue || { baseForm: {}, templateJson: {} }
      const newData = {
        ...currentFullJson,
        baseForm: { ...form },
      }
      emit('template-change', newData)
      emit('update:modelValue', newData)
    }
  },
)

// 监听modelValue变化（tempJson部分）
// watch(
//   () => props.modelValue?.templateJson,
//   (newTempJson) => {
//     console.log('%ctemplateJson change', 'color: green; font-size: 12px;')
//     if (printInstance.value && newTempJson) {
//       // 更新之前获取选中表格状态
//       const qids = getSelectTable(printInstance.value)
//         .map((e: any) => e.options.qid)
//         .filter(Boolean)

//       printInstance.value.update(newTempJson)

//       // 更新之后恢复选中表格状态
//       if (qids?.length) {
//         const allTables = getAllTables(printInstance.value)
//         const tableBK = allTables.filter((e: any) => qids.includes(e.options.qid))
//         const tableBkID = tableBK.map((e: any) => e.id)

//         const tableElements = document.querySelectorAll('.hiprint-printElement-table')
//         tableElements.forEach((e: any) => {
//           const tableID = e.getAttribute('tableID')
//           if (tableBkID.includes(tableID)) {
//             e.classList.add('table-active')
//           }
//         })
//       }
//     }
//   },
//   { deep: true },
// )

/**
 * 初始化函数
 */
import initData from '@/components/utils/init-panel.js'
const init = async () => {
  const language = currentLanguage.value
  // hiprint组件相关配置项初始化
  hiprint.init({
    providers: [
      new defaultElementTypeProvider([...businessFields.value.map((e) => e.variables).flat()]),
    ],
    lang: language,
  })
  // 还原配置
  hiprint.setConfig()
  hiprint.PrintElementTypeManager.buildByHtml(window.$('.ep-draggable-item'))
  window.$('#hiprint-printTemplate').empty()
  // 手动触发语言同步，确保hiprint语言正确设置
  await syncHiprintLanguage(language)
  // 判断templateJson是否为空（undefined、null或空对象）
  const templateJson = props.modelValue?.templateJson
  const isEmptyTemplate =
    !templateJson ||
    templateJson === null ||
    (typeof templateJson === 'object' && Object.keys(templateJson).length === 0)

  // 初始化打印实例
  printInstance.value = new hiprint.PrintTemplate({
    template: isEmptyTemplate ? initData : templateJson,
    // 图片选择功能
    onImageChooseClick: handleImageChooseClick,
    // 自定义可选字体
    fontList: [
      { title: t('designer.fonts.microsoftYaHei'), value: 'Microsoft YaHei' },
      { title: t('designer.fonts.blackFont'), value: 'STHeitiSC-Light' },
      { title: t('designer.fonts.sourceHanSans'), value: 'SourceHanSansCN-Normal' },
      { title: t('designer.fonts.wangXiZhi'), value: 'WangXiZhiCalligraphy' },
      { title: t('designer.fonts.simsun'), value: 'SimSun' },
      { title: t('designer.fonts.stkaiti'), value: 'STKaiti' },
      { title: 'cursive', value: 'cursive' },
    ],
    dataMode: 1, // 1:getJson 其他：getJsonTid 默认1
    history: true, // 是否需要 撤销重做功能
    willOutOfBounds: true, // 是否允许组件内的控件超出范围
    qtDesigner: true, // 是否开启类似QT Designer的唯一field生成模式
    onDataChanged: (type: string, json: any) => {
      console.log('%conDataChanged', 'color: blue; font-size: 12px;')
      const templateJson = JSON.parse(JSON.stringify(json, null, 2))
      const currentFullJson = props.modelValue || { baseForm: {}, templateJson: {} }
      const newData = {
        ...currentFullJson,
        templateJson,
        baseForm: { ...form },
      }
      emit('template-change', newData)
      emit('update:modelValue', newData)
    },
    onUpdateError: (e: any) => {
      emit('template-error', e)
    },
    settingContainer: '#PrintElementOptionSetting',
    paginationContainer: '.hiprint-printPagination',
  })

  printInstance.value.design('#hiprint-printTemplate', { grid: grid.value })
  // 获取当前放大比例, 当zoom时传true 才会有
  scaleValue.value = (printInstance.value.editingPanel.scale || 1) * 100
  emit('template-init', printInstance.value)
  if (isEmptyTemplate) {
    const initModelValue = {
      ...props.modelValue,
      templateJson: initData,
    }
    emit('template-change', initModelValue)
    emit('update:modelValue', initModelValue)
  }
}
// 是否显示网格切换
const toggleGrid = () => {
  grid.value = !grid.value
  printInstance.value?.toggleGrid(grid.value)
}

// 生命周期
onMounted(async () => {
  // 在组件加载时就准备打印环境，确保 hiprint 能找到必要的 link 标签
  preparePrintEnvironment()

  hiprint = vuePluginHiprint.hiprint
  defaultElementTypeProvider = vuePluginHiprint.defaultElementTypeProvider
  collapseRef.value.setActiveNames([
    'basecontrols',
    ...businessFields.value.filter((e) => e.defaultExpand).map((e) => e.id),
  ])
})

// 暴露api给外部调用 - 带严格类型定义
defineExpose<{
  /** 初始化打印设计器 */
  init: () => Promise<void>
  /** 执行打印操作 */
  printAction: typeof printAction
  /** 导出PDF */
  exportPDF: typeof exportPDF
  /** 刷新业务字段 */
  refreshBusinessFields: () => void
  /** 获取当前配置 */
  getConfig: () => typeof resolvedConfig.value
  /** 获取打印实例 */
  getPrintInstance: () => any
}>({
  init,
  printAction,
  exportPDF,
  refreshBusinessFields,
  getConfig: () => resolvedConfig.value,
  getPrintInstance: () => printInstance.value,
})
</script>

<style lang="scss" scoped>
.custom-hiprint {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .custom-hiprint-header {
    width: 100%;
    height: 50px;
    background-color: #fff;
    display: flex;
    align-items: center;
    column-gap: 12px;
    justify-content: flex-start;
    padding: 8px 16px;
    box-sizing: border-box;
    border-bottom: 1px solid oklch(92.2% 0 0);
    .scale-value {
      color: oklch(55.6% 0 0);
      font-size: 14px;
      cursor: pointer;
    }
  }
  .custom-hiprint-content {
    height: calc(100% - 50px);
    flex: 1;
    display: flex;
    overflow: hidden;
    .custom-hiprint-menu {
      :deep(.el-scrollbar) {
        overflow: visible;
        .el-scrollbar__bar.is-vertical {
          right: -10px;
        }
      }
      width: 360px;
      height: 100%;
      background-color: #fff;
      border-radius: 4px 0 0 4px;
      padding: 10px;
      box-sizing: border-box;
      border-right: 1px solid oklch(92.2% 0 0);
      .base-info-form {
        .el-form-item {
          ::v-deep .el-form-item__label {
            color: oklch(14.5% 0 0);
            font-size: 14px;
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      // 纸张尺寸输入框组合样式 - 模仿图片效果
      .paper-size-group {
        display: flex;
        .size-input-first {
          flex: 1;
          margin-right: -1px;

          :deep(.el-input__wrapper) {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            border-right: none;
          }

          :deep(.el-input__inner) {
            text-align: center;
          }
        }

        .size-input-last {
          flex: 1;
          margin-left: -1px;

          :deep(.el-input__wrapper) {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            border-left: 1px solid #dcdfe6;
          }

          :deep(.el-input__inner) {
            text-align: center;
          }

          :deep(.el-input-group__append) {
            background-color: #f5f7fa;
            border-left: 1px solid #dcdfe6;
            color: #909399;
            font-size: 12px;
            padding: 0 12px;
            min-width: 36px;
          }
        }
        // 悬停状态
        &:hover {
          .size-input-first :deep(.el-input__wrapper),
          .size-input-last :deep(.el-input__wrapper) {
            border-color: #c0c4cc;
          }
        }
        // 移除数字输入框的上下箭头
        :deep(.el-input__inner[type='number']) {
          -moz-appearance: textfield;

          &::-webkit-outer-spin-button,
          &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }
        }
      }
      ::v-deep .el-collapse {
        border-top: none;
        border-bottom: none;
        .el-collapse-item {
          .el-collapse-item__header {
            .el-collapse-item__title {
              font-weight: 700 !important;
              font-size: 14px;
            }
          }
        }
      }
      .base-controls {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        .drag_item_box {
          width: 72px;
          height: 72px;
          background-color: #fff;
          border-radius: 4px;
          border: 1px solid oklch(92.2% 0 0);
          box-shadow:
            0 1px 3px 0 oklch(0% 0 0 / 10%),
            0 1px 2px -1px oklch(0% 0 0 / 10%);
          .ep-draggable-item {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            color: oklch(14.5% 0 0);
            .control-item-name {
              width: 100%;
              box-sizing: border-box;
              padding: 0 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              text-align: center;
            }
            .erp-print-iconfont {
              font-size: 32px;
              line-height: 1;
              color: #909399;
            }
            &:hover {
              color: oklch(54.6% 0.245 262.881);
              .erp-print-iconfont {
                color: oklch(54.6% 0.245 262.881);
              }
            }
          }
        }
      }
      .business-fields {
        .business-fields-list {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          .drag_item_box {
            width: calc((100% - 24px) / 3);
            .business-field-item {
              width: 100%;
              overflow: hidden;
              display: block;
              text-align: center;
              background-color: #fff;
              color: oklch(14.5% 0 0);
              font-size: 16px;
              line-height: 16px;
              border-radius: 4px;
              border: 1px solid oklch(92.2% 0 0);
              box-shadow:
                0 1px 3px 0 oklch(0% 0 0 / 10%),
                0 1px 2px -1px oklch(0% 0 0 / 10%);
              font-size: 12px;
              padding: 5px 10px;
              box-sizing: border-box;
              word-break: break-word;
              text-overflow: ellipsis;
              white-space: nowrap;
              &:hover {
                cursor: pointer;
                color: #005bf5;
              }
            }
          }
        }
      }
    }
    .custom-hiprint-content-body {
      // width: 100%;
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: row;
      overflow: hidden;
      .hiprint-printTemplate {
        flex: 1;
        height: 100%;
        padding: 30px 20px;
        box-sizing: border-box;
        overflow: auto;
        background-color: #f5f7fa;
        ::v-deep .hiprint-printPaper {
          background-color: #fff;
          margin: auto;
        }
      }
      .hiprint-printTemplate-setting {
        flex-shrink: 0;
        width: 320px;
        height: 100%;
        background: #fff;
        overflow: auto;
        border-left: 1px solid oklch(92.2% 0 0);
        box-sizing: border-box;
        .setting-title {
          color: oklch(14.5% 0 0);
          font-size: 16px;
          padding: 10px 10px;
          box-sizing: border-box;
          border-bottom: 1px solid oklch(92.2% 0 0);
          font-weight: 600;
        }
        .params_setting_container {
          height: calc(100% - 40px);
          .empty-setting {
            color: oklch(55.6% 0 0);
            margin: 80px auto;
            font-size: 14px;
            text-align: center;
            padding: 10px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .el-icon {
              font-size: 32px;
              margin-bottom: 10px;
            }
          }
        }
      }
    }
  }
}

.operate-icon-btn {
  padding: 4px 6px;
  border-radius: 4px;
  color: #909399;
  &:hover {
    color: #409eff;
    background-color: #005bf50f !important;
    outline: none;
  }
  &:focus-visible {
    outline: none;
  }
}
.operate-icon-btn + .operate-icon-btn {
  margin-left: 0px;
}

.grid-on {
  background-color: #005bf50f;
}
.grid-off {
  background-color: transparent;
}

.vertical-line {
  width: 1px;
  height: 100%;
  background-color: oklch(92.2% 0 0);
  flex-shrink: 0;
}
</style>
